import { render, staticRenderFns } from "./EventsNearLocation.vue?vue&type=template&id=de629d5c&scoped=true&"
import script from "./EventsNearLocation.vue?vue&type=script&lang=js&"
export * from "./EventsNearLocation.vue?vue&type=script&lang=js&"
import style0 from "./EventsNearLocation.vue?vue&type=style&index=0&id=de629d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de629d5c",
  null
  
)

export default component.exports